<template>
  <div class="qimingxing">
    <PublicScore :logo="Logo3" :type="'qmx'" :color="'#36b9bf'" />
  </div>
</template>

<script>
import PublicScore from '../component/scoreQuery.vue'
import Logo3 from '@/assets/images/logo3.png'

export default {
  name: 'QiMingXing',
  components: {
    PublicScore
  },
  data() {
    return {
      Logo3
    }
  }
}
</script>
